import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import dropin from 'braintree-web-drop-in';
import { ToastContainer } from 'react-toastr';
import { Button, Col, Row, FormGroup, InputGroup } from 'react-bootstrap';

import { updateMealPlan } from '../../redux/actions/authenticationActions';
import { submitTopUpRequest } from '../../api/api';
import { LoadingText } from '../common/Loading';
import '../../public/css/MyAccount.css';
import { CHECKOUT } from '../../util/avialableRoutes';
import { isPayPalEnabled } from '../dashboard/reducer';
import defaultMsg from '../../translations/lang/en-US.json';

export class MealPlanInfo extends Component {
  state = {
    topUpAmount: this.props.addFunds,
    error: false,
    isInCheckout: false,
    isPaymentRequestable: false,
    loadingPaypalFrame: false,
    instance: false,
    checkingOut: false,
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.wasInCheckout === true) {
      this.resetDropInData();
    }
  }

  resetDropInData = () => {
    if (this.props.addFunds) {
      window.location.replace(`/${this.props.rname}/${CHECKOUT}`);
    } else {
      this.setState({
        topUpAmount: '',
        error: false,
        isInCheckout: false,
        isPaymentRequestable: false,
        instance: false,
        checkingOut: false,
      });
    }
  };

  teardownDropIn = instance => {
    if (instance) {
      instance.teardown();
      this.resetDropInData();
    }
    this.props.disableClick(false);
  };

  submitPayment = (instance, data = {}) => {
    const { tokenId, jwt, user, dataname } = this.props;
    this.setState({ checkingOut: true });
    submitTopUpRequest({ ...data, user: user.id, tokenId, jwt, dataname })
      .then(response => {
        const mealplanSettings = response.data.DataResponse.mealplan;
        this.props.actions.updateMealPlan(mealplanSettings);
        this.props.onMealPlanSettingChange(mealplanSettings);
        this.toastContainer.success(
          `Balance: ${response.data.DataResponse.mealplan.card_balance}`
        );
        this.teardownDropIn(instance);
      })
      .catch(err => {
        this.setState({
          error: err.message,
          checkingOut: true,
        });
        this.toastContainer.error(err.message, null, {
          timeOut: 0,
          closeButton: true,
        });
      });
  };

  setupDropInInstance = (err, instance) => {
    const { topUpAmount } = this.state;
    if (err) {
      this.toastContainer.error(err);
      return this.setState({ error: err, isInCheckout: false });
    }

    const submit = data => {
      instance.requestPaymentMethod((err, payload) => {
        if (err) {
          this.setState({ error: err });
          return;
        }
        this.setState({ instance: instance });
        this.submitPayment(instance, {
          nonce: payload.nonce,
          amount: topUpAmount,
        });
      });
    };

    this.checkout = submit;

    instance.on('paymentMethodRequestable', event => {
      this.setState({ isPaymentRequestable: true });
    });

    instance.on('noPaymentMethodRequestable', () => {
      this.setState({ isPaymentRequestable: false });
    });

    this.setState({ loadingPaypalFrame: false, instance: instance });
  };

  onTopUpInputSubmit = e => {
    e.preventDefault();
    if (!this.isTopUpValid()) {
      return false;
    }

    this.setState({ isInCheckout: true, loadingPaypalFrame: true });
    this.props.disableClick(true);
    dropin.create(
      {
        authorization: this.props.dashboardData.merchantDetails.ltg_payment_info
          .paypal.paypal_token,
        container: '#dropin-container',
        card: {
          cardholderName: {
            required: true,
          },
        },
      },
      this.setupDropInInstance
    );
  };

  onCheckoutSubmit = e => {
    e.preventDefault();
    if (!this.state.isPaymentRequestable) {
      return false;
    }

    this.checkout && this.checkout();
  };

  handleTopUpChange = e => {
    const amount = e.target.value;
    if (this.isTopUpValid(amount)) {
      this.setState({
        topUpAmount: amount,
      });
    }
  };

  isTopUpValid = amount => {
    const topUpAmount = amount || this.state.topUpAmount;
    const currencyMatcher = /^[0-9]+(\.[0-9]{0,2})?$/;
    return currencyMatcher.test(topUpAmount);
  };

  calcTotalBalance = () => {
    const { card_balance, stipend_balance } = this.props.mealPlan;
    return +card_balance + +stipend_balance;
  };

  render() {
    const { badge_number, card_balance, stipend_balance } = this.props.mealPlan;

    return (
      <div className="fullContent">
        <ToastContainer ref={ref => (this.toastContainer = ref)} />
        <Row className="page-title">
          <Col md={12}>
            <h4>
              <FormattedMessage
                id="mealPlanHead"
                defaultMessage={defaultMsg.mealPlanHead}
              />
            </h4>
          </Col>
        </Row>
        <Row className="page-content">
          {this.props.loadingMealPlanSetting ? (
            <LoadingText />
          ) : (
            <Col md={6} xs={12} lg={6}>
              <h4>
                <FormattedMessage
                  id="mealPlanBalanceHeader"
                  defaultMessage={defaultMsg.mealPlanBalanceHeader}
                />
              </h4>
              <br />
              <Col md={12}>
                <Row>
                  <div className="form-group">
                    <label>
                      <FormattedMessage
                        id="mealPlanBadgeNumber"
                        defaultMessage={defaultMsg.mealPlanBadgeNumber}
                      />
                    </label>
                    <input
                      id="badgeNumber"
                      className="form-control"
                      value={badge_number}
                      readOnly
                    />
                  </div>
                </Row>
              </Col>
              <Col md={12}>
                <Row>
                  <div className="form-group">
                    <label>
                      <FormattedMessage
                        id="mealPlanCashBalance"
                        defaultMessage={defaultMsg.mealPlanCashBalance}
                      />
                    </label>
                    <input
                      id="cardBalance"
                      className="form-control"
                      value={card_balance}
                      readOnly
                    />
                  </div>
                </Row>
              </Col>
              <Col md={12}>
                <Row>
                  <div className="form-group">
                    <label className="input-group__label">
                      <FormattedMessage
                        id="mealPlanStipendBalance"
                        defaultMessage={defaultMsg.mealPlanStipendBalance}
                      />
                    </label>
                    <input
                      id="stipendBalance"
                      className="form-control"
                      value={stipend_balance}
                      readOnly
                    />
                  </div>
                </Row>
              </Col>
              <Col md={12}>
                <Row>
                  <div className="form-group">
                    <label className="input-group__label">
                      <FormattedMessage
                        id="mealPlanTotalBalance"
                        defaultMessage={defaultMsg.mealPlanTotalBalance}
                      />
                    </label>
                    <input
                      id="totalBalance"
                      className="form-control"
                      value={this.calcTotalBalance()}
                      readOnly
                    />
                  </div>
                </Row>
              </Col>
            </Col>
          )}
          {!this.props.loadingMealPlanSetting && this.props.isPayPalEnabled? (
            <Col xs={12} md={6} lg={6}>
              <h4>
                <FormattedMessage
                  id="addCashToMealPlanHeader"
                  defaultMessage={defaultMsg.addCashToMealPlanHeader}
                />
              </h4>
              <br />
              {!this.state.isInCheckout ? (
                <form onSubmit={this.onTopUpInputSubmit}>
                  <div className="meal-plan-add-cash-input-field">
                    <Col md={8}>
                      <FormGroup>
                        <label>
                          <FormattedMessage
                            id="enterCashAmount"
                            defaultMessage={defaultMsg.enterCashAmount}
                          />
                        </label>
                        <InputGroup>
                          <input
                            type="text"
                            className="input__topup input-group__input shorter form-control"
                            value={this.state.topUpAmount}
                            onChange={this.handleTopUpChange}
                          />
                          <InputGroup.Button>
                            <Button
                              className="button__primary btn btn-success diningButton checkout__button--paypal"
                              disabled={!this.isTopUpValid()}
                              type="submit"
                            >
                              <FormattedMessage
                                id="addCash"
                                defaultMessage={defaultMsg.addCash}
                              />
                            </Button>
                          </InputGroup.Button>
                        </InputGroup>
                      </FormGroup>
                    </Col>
                  </div>
                </form>
              ) : null}
              <div className="checkout-box">
                <form onSubmit={this.onCheckoutSubmit}>
                  <div id="dropin-container" />
                  <div className="checkout-in-dropin">
                    {this.state.loadingPaypalFrame ? (
                      <FormattedMessage
                        id="loadingText"
                        defaultMessage={defaultMsg.loadingText}
                      />
                    ) : null}
                    {this.state.isInCheckout &&
                    !this.state.loadingPaypalFrame ? (
                      <div className="text-center">
                        <button
                          className="pull-left btn btn-default btn-style alignCenter olo-client-theme-background olo-client-theme-border olo-client-theme-color-white space-checkout-btn"
                          type="submit"
                          disabled={
                            !this.state.isPaymentRequestable ||
                            this.state.checkingOut
                          }
                        >
                          {!this.state.checkingOut
                            ? 
                            <FormattedMessage
                              id="checkout"
                              defaultMessage={defaultMsg.checkout}
                            />
                            : 
                            <FormattedMessage
                              id="updatingCashBalance"
                              defaultMessage={defaultMsg.updatingCashBalance}
                            />
                          }
                        </button>

                        <button
                          className="pull-right btn btn-default alignCenter order-btn inactive space-checkout-btn"
                          type="button"
                          onClick={() =>
                            this.teardownDropIn(this.state.instance)
                          }
                        >
                          <FormattedMessage
                            id="cancel"
                            defaultMessage={defaultMsg.cancel}
                          />
                        </button>
                      </div>
                    ) : null}
                  </div>
                </form>
              </div>
            </Col>
          ) : null}
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.auth.loginUserDetails,
  dataname: state.dashboard.dataName,
  tokenId: state.auth.tokenId,
  jwt: state.auth.jwt,
  dashboardData: state.dashboard,
  isPayPalEnabled: isPayPalEnabled(state)
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      updateMealPlan,
    },
    dispatch
  ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MealPlanInfo);



// WEBPACK FOOTER //
// ./src/views/myaccount/MealPlanInfo.js